import styled from 'styled-components';

/**
 * The editing row of a content editor modal: a main area beside a sidebar.
 * It claims the dialog height so the item list below it falls past the fold,
 * which is what keeps the editing area large.
 */
export const EditorModalLayout = styled.div`
  display: flex;
  height: calc(100% - 60px);
  border: 1px solid var(--gray-dark);
  border-radius: var(--medium-border-radius);
  overflow: hidden;
`;
